<div class="mt-4">
  <h2 class="modal-title text-center animated fadeInDown text-secondary-800 h2-bold">
    Welcome to Our New Site!
  </h2>
  <h5 class="fw-normal text-secondary-700 m-auto" [class.w-75]="!isMobile()" [class.w-100]="isMobile()"
    [class.text-center]="isMobile()" [class.text-start]="!isMobile()">
    <br />
    Dear {{customerName()}},
    <br />
    <br />
    We’ve upgraded your shopping experience with our new website!
    <br />
    <br />
    We did our best to carry over <b>your existing order edits</b>, but we kindly ask that you <b>review your cart</b>
    to make sure
    everything looks right for <b>next week’s delivery</b>.
    <br />
    <br />
    Thank you for your continued support and for helping us grow!
  </h5>

  <div class="row mt-5">
    <div class="col col-md-6 d-grid">
      <button type="button" class="btn btn-primary" (click)="confirmModalButtonsAction(false)">Review My
        Order</button>
    </div>
    <div class="col col-md-6 d-grid">
      <button type="button" class="btn btn-outline-primary" (click)="confirmModalButtonsAction(true)">Don’t Show This
        Again</button>
    </div>
  </div>
</div>